import type { SxStyle } from '@aibees/shared/theme';

/** Fixed content height so switching tabs doesn't resize the dialog: the editor
 *  flexes to fill whatever the alert / method box above it leaves. */
const CONTENT_HEIGHT = 480;

export const prepend: SxStyle = {
  flex: 1,
  display: 'flex',
};

export const content: SxStyle = {
  height: CONTENT_HEIGHT,
};

export const docsLink: SxStyle = {
  fontWeight: 600,
};

export const methodRow: SxStyle = {
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: 0.5,
};

export const url: SxStyle = {
  textTransform: 'none !important',
};

/** The shared Label centers its content; the URL should read from the left. */
export const urlLabel: SxStyle = {
  justifyContent: 'flex-start',
};

export const method: SxStyle = {
  textTransform: 'capitalize !important',
};

export const editorWrapper: SxStyle = {
  flex: 1,
  minHeight: 0,
};

export const error: SxStyle = {
  display: 'block',
  color: 'error.main',
};
